import React, { useState } from "react";
import {
  MapContainer,
  TileLayer,
  GeoJSON,
  LayersControl,
  useMapEvents,
} from "react-leaflet";
import "./leaflet-styling.css";
import FoodStreet from "../../data/basemaps/FoodStreet.json";
import FoodStreetResolution14 from "../../data/basemaps/FoodStreetResolution14.json";
import FoodStreetResolution15 from "../../data/basemaps/FoodStreetResolution15";
import { h3IndexToSplitLong, latLngToCell, cellToLatLng } from "h3-js";
import { getLocnIdfromH3Id, getH3IdfromLocnId } from "../../locn/locn-utility";
import geojson2h3 from "geojson2h3";
import { toast } from "react-hot-toast";
import {
  useQueryParam,
  NumberParam,
  StringParam,
  withDefault,
} from "use-query-params";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { history } from "../../index";
import NavigateIcon from "../../images/map.png";
import CopyLinkIcon from "../../images/copy-link.png";

function LocnFoodStreet() {
  const minResolutionLevel = 13;
  const [lat, setLat] = useQueryParam(
    "lat",
    withDefault(NumberParam, 12.951230480006144)
  );
  const [long, setLong] = useQueryParam(
    "long",
    withDefault(NumberParam, 77.57745556533337)
  );
  const [locnId, setLocnId] = useQueryParam(
    "locnId",
    withDefault(StringParam, "3hqfptpkc-46820")
  );

  const [locnIdClicked, setLocnIdClicked] = useState(locnId);

  // const [lat, setLat] = useState(12.951230480006144);
  // const [long, setLong] = useState(77.57745556533337);
  const [zoomLevel, setZoomLevel] = useState(22);

  // For map generation
  // const resolution = 15;
  // const hexagons = geojson2h3.featureToH3Set(FoodStreet.features[0], resolution);
  // const feature = geojson2h3.h3SetToMultiPolygonFeature(hexagons);
  // console.log('geoJSON' + resolution);
  // console.log(feature);

  // let getLatLongFromClick = (e) => {
  //   alert("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng)
  // }

  let getCellFromClick = (e, resolution) => {
    const lat = e.latlng.lat;
    const long = e.latlng.lng;
    console.log(lat, long, resolution);
    const cell = latLngToCell(lat, long, resolution);
    return cell;
  };

  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    const href = window.location.href;
    copyTextToClipboard(href)
      .then(() => {
        toast.success("Copied to clipboard");
      })
      .catch((err) => {
        toast.error("Error Copying");
      });
  };

  let onHexClick = (e, resolution) => {
    // console.log(e.target);
    // e.target.setStyle({
    //   fillColor : selectedColor,
    // });
    // console.log("onHexClick - Set color from state is : " + selectedColor);
    const h3CellId = getCellFromClick(e, resolution);
    // console.log('h3CellId');
    // console.log(h3CellId);
    let popup = e.target.getPopup();
    // console.log(popup);
    const lat = e.latlng.lat;
    const long = e.latlng.lng;
    const locnIdFromClick = getLocnIdfromH3Id(h3CellId);
    history.push({
      pathname: "/locn-foodstreet",
      search: `?locnId=${locnIdFromClick}`,
    });
    setLocnIdClicked(locnIdFromClick);
    let popupContent = "You need to zoom further to get an locnId";
    if (resolution === 15) {
      //   const content = <div class="text-white flex-shrink-1">
      //   <div class="p-3 locn-id flex items-center font-semibold text-[1rem]">ID: ${locnIdFromClick}</div>
      //   <div class="actions flex items-center text-center h-10 p-1">
      //     <div class="navigate"><a class="color-white pr-2 flex items-center" target="_blank" href="https://maps.google.com/?q=${lat},${long}"><img class="pr-2" src={NavigateIcon} style={{ height: 55, width: 50 }}/> <span>Navigate</span></a></div>
      //     <div class="copy-link"> <a class="color-white pr-2 flex items-center font-semibold" href="#" onClick="handleCopyClick()"> <img class="pr-2" src={CopyLinkIcon} style={{ height: 60 }} /><span>Copy Link</span></a></div>
      //   </div>
      // </div>;

      popupContent = `
      <div class="text-white flex-shrink-1">
        <div class="p-3 locn-id flex items-center font-semibold text-[1rem]">ID: ${locnIdFromClick}</div>
        <div class="actions flex items-center text-center h-10 p-1">
          <div class="navigate"><a class="color-white pr-2 flex items-center" target="_blank" href="https://maps.google.com/?q=${lat},${long}"><img class="pr-2" src=${NavigateIcon} style=${{
        height: 55,
        width: 50,
      }}/> <span>Navigate</span></a></div>
          <div class="copy-link"> <a class="color-white pr-2 flex items-center font-semibold cursor-pointer" id="clipboard-button"> <img class="pr-2" src=${CopyLinkIcon} style=${{
        height: 60,
      }} /><span>Copy Link</span></a></div>
        </div>
      </div>
      `;
    }

    // <div>ID: <a href="locn-foodstreet?locnId=${locnIdFromClick}">${locnIdFromClick}</a></div>
    // <div>h3cellId - ${h3CellId}</div>
    // <div>lat - ${lat}</div>
    // <div>long - ${long}</div>

    popup.setContent(popupContent);
    const copyButton = document.getElementById("clipboard-button");
    copyButton.addEventListener("click", handleCopyClick);
  };

  //<div>h3cellId - ${h3CellId}</div>
  // <div>lat - ${lat}</div>
  // <div>long - ${long}</div>

  // let onWardMouseOver = (e) => {
  //   return;
  //   e.target.setStyle({
  //     fillColor : '#0000FF',
  //   });
  // }

  // const changeColor = (e) => {
  //   console.log("Color from state is : " + selectedColor);
  //   console.log("Changing the color to : " + e.target.value);
  //   setSelectedColor(e.target.value);
  // }

  const onLeafletClickClosure = (resolution) => {
    return function onLeafletClick(e) {
      console.log("Clicked with resolution " + resolution);
      onHexClick(e, resolution);
    };
  };

  const onEachHex = (feature, layer, resolution) => {
    // console.log(JSON.stringify(w.properties));
    // console.log(layer);
    // console.log(feature);
    layer.bindPopup(
      "Placeholder text - The resolution of this layer is " + " - " + resolution
    );
    layer.on({
      // click : onLeafletClickClosure(resolution),
      click: onLeafletClickClosure(resolution),
    });
  };

  const showLayer = (layerResolution) => {
    if (getH3ResolutionFromLeafletZoom(zoomLevel) === layerResolution) {
      return true;
    } else {
      return false;
    }
  };

  const getH3ResolutionFromLeafletZoom = (leafletZoom) => {
    let resolution;
    if (zoomLevel < 18) {
      resolution = 10;
    } else if (zoomLevel >= 18 && zoomLevel <= 19) {
      resolution = 11;
    } else if (zoomLevel > 19 && zoomLevel <= 20) {
      resolution = 12;
    } else if (zoomLevel > 20 && zoomLevel <= 23) {
      resolution = 14;
    } else {
      resolution = 15;
    }
    return resolution;
  };

  const ZOOM_TO_H3_RES_MAPPING = {
    5: 1,
    6: 2,
    7: 3,
    8: 3,
    9: 4,
    10: 5,
    11: 6,
    12: 6,
    13: 7,
    14: 8,
    15: 9,
    16: 9,
    17: 10,
    18: 10,
    19: 11,
    20: 11,
    21: 12,
    22: 13,
    23: 14,
    24: 15,
  };

  const ZoomLevelChanged = () => {
    const mapEvents = useMapEvents({
      zoomend: () => {
        console.log("Zoom End");
        console.log(mapEvents.getZoom());
        setZoomLevel(mapEvents.getZoom());
      },
    });
    return null;
  };

  const h3Id = getH3IdfromLocnId(locnId);
  const [h3IdLat, h3IdLong] = cellToLatLng(h3Id);

  // const handleCopyClick = (e) => {
  //   e.preventDefault();
  //   alert("getting copied?");
  //   navigator.clipboard.writeText("url copied");
  // };

  const debugLogger = () => {
    console.log(
      "Rendering with zoome level - " +
        zoomLevel +
        " resolution - " +
        getH3ResolutionFromLeafletZoom(zoomLevel)
    );
    console.log("h3ID - " + h3Id);
    console.log(h3IdLat);
    console.log(h3IdLong);
  };

  // Reference - https://leafletjs.com/examples/choropleth/
  return (
    <>
      {debugLogger()}
      {/* cellToLatLng */}
      <div className="bg-neutral-200 text-lg text-center p-2">
        Locn Id :{" "}
        <a href={`locn-foodstreet?locnId=${locnIdClicked}`}>{locnIdClicked}</a>{" "}
      </div>
      <MapContainer
        center={[h3IdLat, h3IdLong]}
        zoomSnap={1}
        zoom={zoomLevel}
        maxZoom={34}
        scrollWheelZoom={true}
      >
        <ZoomLevelChanged />
        {/* <Search provider={new OpenStreetMapProvider()} /> */}
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          opacity="0.9"
          maxNativeZoom={19}
          minZoom={21}
          maxZoom={24}
        />
        <GeoJSON
          data={FoodStreet.features}
          style={{ fillColor: "white", color: "grey" }}
        />
        <GeoJSON
          data={FoodStreetResolution15.features}
          style={{ fillColor: "white", color: "grey", weight: 1, opacity: 0.3 }}
          onEachFeature={(f, l) => onEachHex(f, l, 15)}
        />
        {/* <LayersControl position="topright">
        <LayersControl.Overlay checked={true} name="Bangalore">
            <GeoJSON data={FoodStreet.features} style={{fillColor: 'red', color: 'black'}}/>
        </LayersControl.Overlay>        
        <LayersControl.Overlay checked={showLayer(14)} name="Resolution14">
            <GeoJSON data={FoodStreetResolution14.features} style={{fillColor: 'red', color: 'black', weight:1}} onEachFeature={(f,l) => onEachHex(f,l, 14)} />
        </LayersControl.Overlay>        
        <LayersControl.Overlay checked={showLayer(15)} name="Resolution15">
            <GeoJSON data={FoodStreetResolution15.features} style={{fillColor: 'red', color: 'black', weight:1}} onEachFeature={(f,l) => onEachHex(f,l, 15)} />
        </LayersControl.Overlay>    
      </LayersControl> */}
      </MapContainer>
      {/* <input type = "color" value = {selectedColor} onChange = {changeColor} /> */}
    </>
  );
}

export default LocnFoodStreet;
